import ModalBase from '../../../ModalBase/ModalBase';

function ConfirmationModal({ isOpen, toggle, handleSubmit }) {
  return (
    <ModalBase
      isOpen={isOpen}
      toggle={toggle}
      header="Disclaimer"
      body={
        <>
          Submitted questions become the property of Promotion Wingman, and may
          be modified, to include deletion, for any reason, without
          notification.
        </>
      }
      footer={
        <>
          <button
            data-test="disgree-modal-submit-question-button"
            className="btn modal-base-btn secondary"
            onClick={toggle}
          >
            Disagree
          </button>
          <button
            data-test="agree-modal-submit-question-button"
            className="btn modal-base-btn primary"
            onClick={(e) => {
              handleSubmit(e);
              toggle();
            }}
          >
            Agree
          </button>
        </>
      }
    />
  );
}

export default ConfirmationModal;
